import React from 'react'
import styles from './ScreenRowLayout.module.scss'
import classnames from 'classnames'

const ScreenRowLayout = ({ children }) => {

  const validCompCount = Number(React.Children.toArray(children)
    .reduce((validCompCount: number, child) =>
      React.isValidElement(child)
        ? validCompCount + 1
        : validCompCount
    , 0
    ))

  const layoutClasses = classnames(
    styles['screen-row-layout'], {
      [styles['screen-row-layout-grid']]: validCompCount > 1
    }
  )

  return <div className={layoutClasses}>
    {children}
  </div>

}

export default ScreenRowLayout
